module.exports = __webpack_public_path__ + "static/img/mechanism-4.5b098df3.png";